import React from 'react';

import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { defaultGraphConfig, generateLabels } from 'utils/graphs';
import {
  AvgMaxCountAccess,
  PerformanceCPUGraphFields,
} from 'modules/environments/interfaces';
import { roundToFixedTwoWithPercentage } from 'utils/helpers';

interface CPUGraphProps {
  filter: AvgMaxCountAccess | string;
  environmentPerformanceCPU: PerformanceCPUGraphFields;
}

const CPUGraph = ({ filter, environmentPerformanceCPU }: CPUGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(environmentPerformanceCPU?.metrics);

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: environmentPerformanceCPU?.metrics?.map(
          filter === 'avg' ? item => item.cpu.avg : item => item.cpu.max
        ),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
    ],
  });

  config.options.scales.xAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.beginAtZero = true;
  config.options.scales.yAxes[0].ticks.max = 100;

  config.options.tooltips = {
    callbacks: {
      label(tooltipItem) {
        return roundToFixedTwoWithPercentage(tooltipItem.value);
      },
    },
    displayColors: false,
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentPerformanceCPU },
}: ApplicationState) => ({
  environmentPerformanceCPU,
});

export default connect(mapStateToProps, {})(CPUGraph);
